import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

// Pede o motivo do cancelamento da NFS-e; quem chama faz o POST /cancelar/nfse
const ModalMotivoCancelamentoNfse = (props) => {

    const [motivo, setMotivo] = useState('');
    const [erro, setErro] = useState(false);

    const handleClose = () => {
        setMotivo('');
        setErro(false);
        props.onClose();
    };

    const handleConfirmar = () => {
        if (!motivo.trim()) {
            setErro(true);
            return;
        }
        props.onConfirm(props.nota?.idNota, motivo.trim());
        handleClose();
    };

    const numero = props.nota?.numeroNota;

    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
                aria-labelledby="cancelar-nfse-title"
                aria-describedby="cancelar-nfse-description"
            >
                <DialogTitle id="cancelar-nfse-title">
                    {numero ? `Cancelar a NFS-e #${numero}?` : "Cancelar esta nota fiscal?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancelar-nfse-description" sx={{ mb: 2 }}>
                        O pedido de cancelamento será enviado para a prefeitura. Informe o motivo do cancelamento abaixo.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        fullWidth
                        multiline
                        minRows={2}
                        size="small"
                        label="Motivo do cancelamento"
                        value={motivo}
                        onChange={(e) => {
                            setMotivo(e.target.value);
                            if (erro) setErro(false);
                        }}
                        error={erro}
                        helperText={erro ? "Informe o motivo do cancelamento." : "Ex.: Emissão de nota fiscal incorreta."}
                        sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff" } }}
                    />
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3, pb: 2 }}>
                    <Button onClick={handleClose} variant='contained' color='success' size='small'>Manter Nota</Button>
                    <Button onClick={handleConfirmar} color='error' size='small'>Cancelar Nota</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default ModalMotivoCancelamentoNfse;
